// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "static/js/main.b3a283e2.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + "b095dc89" + ".chunk.js";
};